module.exports = __webpack_public_path__ + "img/btn_menu_service.5c5aed4a.svg";